import React, { useState } from 'react';
import './currentUser.css';
import { useDispatch, useSelector } from "react-redux";
import { site } from "../../config";
import {
    activationSubscriptionSagaAction,
    confirmEmailSagaAction,
    copySubscriptionSagaAction,
    deactivateSubscriptionSagaAction,
    freezeSubscriptionSagaAction,
    getFamilyListSagaAction,
    getUserInfoSagaAction,
    getUserPermissionSagaAction,
    getWorkoutsFromCertainSubscriptionSagaAction,
    removeMissedWorkoutSagaAction,
    removeSubscriptionSagaAction,
    removeUserSagaAction,
    getDepositListSagaAction,
    getChildrenSagaAction
} from "../../redux/sagaActions";
import {
    addSubscriptionFormAction,
    contextAction,
    removeDebtAction,
    setExtendSubscriptionFormAction,
    repayMoneyFormAction,
    subscriptionCalendarAction,
    subscriptionFormAction,
    userFormAction,
    watchPhotoAction,
    dropdownAction,
    setChangeUserPasswordFormAction
} from "../../redux/rootReducer";
import ContextMenu from "../ContextMenu/ContextMenu";
import CurrentWorkouts from "../CurrentWorkouts/CurrentWorkouts";
import Tippy from "@tippyjs/react";
import UserWorkoutsCalendar from "../UserWorkoutsCalendar/UserWorkoutsCalendar";
import UserPermissionForm from "../UserPermissionForm/UserPermissionForm";
import ChoiceDebtSubscription from "../ChoiseDebtSubscription/ChoiseDebtSubscription";
import DepositsList from "../DepositsList/DepositsList";
import DepositForm from "../DepositForm/DepositForm";
import { ADD_SUBSCRIPTION_FORM_INITIAL, CHANGE_USER_PASSWORD_FORM_INITIAL } from "../../redux/initialStateConstant";
import ChildrenForm from "../ChildrenForm/ChildrenForm";
import ChildForm from "../ChildForm/ChildForm";
import ChangeUserPasswordForm from "../ChangeUserPasswordForm/ChangeUserPasswordForm";
import { getDebtListThunk } from "../../redux/thunks/getDebtListThunk";
import { addRecordThunk } from "../../redux/thunks/addRecordThunk";
import DebtList from "../DebtList/DebtList";
import PaymentForm from "../PaymentForm/PaymentForm";

const CurrentUser = () => {
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state.currentUser);
    const context = useSelector(state => state.context);
    const current_subscription = useSelector(state => state.current_subscription);
    const dropdown = useSelector(state => state.dropdown);
    const subscription_types = useSelector(state => state.subscription_types);
    const deposit_list = useSelector(state => state.deposit_list);
    const deposit_form = useSelector(state => state.deposit_form);
    const children_form = useSelector(state => state.children_form);
    const child_form = useSelector(state => state.child_form);
    const change_user_password_form = useSelector(state => state.change_user_password_form);
    const establishmentList = useSelector(state => state.establishmentList);

    const [archive, setArchive] = useState(false);

    let data = null;
    if (currentUser.subscriptions.length  && context) {
        data = currentUser.subscriptions.find(el => el.id === context);
    }

    const menu = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(subscriptionFormAction({
                    open: true,
                    title: `Абонемент № ${ data?.id }`,
                    id: data?.id,
                    user: { id: currentUser.id, name: currentUser.name },
                    users: [],
                    userInput: '',
                    times: data?.times,
                    coach: data?.coach,
                    type: data?.type,
                    time_constraint: data?.time_constraint,
                    note: data?.note,
                    unlim: data?.unlim,
                    expire_date: data?.expire_date,
                    activation_date: data?.activation_date,
                    old_cost: data?.cost,
                    payment: [],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: data?.cost
                }));
            }
        },
        {
            id: '2',
            caption: 'Списать тренировку',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Открываем календарь абонемента
                dispatch(subscriptionCalendarAction({
                    open: true,
                    subscription_id: data?.id
                }));
            }
        },
        {
            id: '3',
            caption: 'Заморозка абонемента',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));

                if (data.freezed === 1) {
                    if (window.confirm('Вы действительно хотите снять заморозку?')) {
                        dispatch(freezeSubscriptionSagaAction({
                            subscription_id: data?.id
                        }));
                    }
                }
                else {
                    if (window.confirm('Вы действительно хотите заморозить абонемент?')) {
                        dispatch(freezeSubscriptionSagaAction({
                            subscription_id: data?.id
                        }));
                    }
                }
            }
        },
        {
            id: '4',
            caption: 'Семейный абонемент',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Запрашиваем список пользователей семейного абонемента
                dispatch(getFamilyListSagaAction({ subscription_id: data.id }));
            },
        },
        {
            id: '5',
            caption: 'Продлить срок действия',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(setExtendSubscriptionFormAction({
                    open: true,
                    subscription_id: data?.id,
                    expire_date: data.expire_date
                }));
            }
        },
        {
            id: '6',
            caption: 'Создать копию',
            handler: () => {

                if (window.confirm('Вы действительно хотите скопировать абонемент?')) {
                    dispatch(copySubscriptionSagaAction({ subscription_id: data.id }));
                }
                dispatch(contextAction(false));
            }
        },
        {
            id: '7',
            caption: 'Деактивировать абонемент',
            handler: () => {
                if (!window.confirm('Вы действительно хотите деактивировать абонемент?')) return;

                dispatch(deactivateSubscriptionSagaAction({ subscription_id: data.id }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '8',
            caption: 'Возврат средств',
            handler: () => {
                dispatch(repayMoneyFormAction({
                    open: true,
                    subscription_id: data.id,
                    sum: '',
                    payment_method: { id: '', name: '' }
                }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '9',
            caption: 'Удалить абонемент',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить абонемент?')) {
                    dispatch(removeSubscriptionSagaAction({ id: data?.id }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    const menuNotActivation = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(subscriptionFormAction({
                    open: true,
                    title: `Абонемент № ${ data?.id }`,
                    id: data?.id,
                    user: { id: currentUser?.id, name: currentUser?.name },
                    users: [],
                    userInput: '',
                    times: data?.times,
                    type: data?.type,
                    coach: data?.coach,
                    time_constraint: data?.time_constraint,
                    note: data?.note,
                    unlim: data?.unlim,
                    expire_date: data?.expire_date,
                    activation_date: data?.activation_date,
                    old_cost: data?.cost,
                    payment: [],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: data?.cost
                }));
            }
        },
        {
            id: '2',
            caption: 'Активировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));

                if (window.confirm('Вы действительно хотите активировать абонемент?')) {
                    dispatch(activationSubscriptionSagaAction({ subscription_id: data?.id }));
                }
            }
        },
        {
            id: '3',
            caption: 'Семейный абонемент',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Запрашиваем список пользователей семейного абонемента
                dispatch(getFamilyListSagaAction({ subscription_id: data.id }));
            },
        },
        {
            id: '4',
            caption: 'Возврат средств',
            handler: () => {
                dispatch(repayMoneyFormAction({
                    open: true,
                    subscription_id: data.id,
                    sum: '',
                    payment_method: { id: '', name: '' }
                }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '5',
            caption: 'Удалить абонемент',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить абонемент?')) {
                    dispatch(removeSubscriptionSagaAction({ id: data.id }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    // Открываем чат в viber
    const openViber = (phone, message = '') => {
        // Форматируем номер телефона (убираем все кроме цифр)
        let formattedPhone = phone.replace(/\D/g, '');
        formattedPhone = '%2B' + formattedPhone;

        // Создаем deeplink для чата
        const viberChatUrl = `viber://chat?number=${ formattedPhone }${
            message ? `&text=${ encodeURIComponent(message) }` : ''
        }`;

        // Создаём невидимую ссылку и программно кликаем
        const link = document.createElement('a');
        link.href = viberChatUrl;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Открываем чат в telegram
    const openTelegram = (phone) => {
        // Форматируем номер телефона (убираем все кроме цифр)
        let formattedPhone = phone.replace(/\D/g, '');
        formattedPhone = '+' + formattedPhone;

        window.open('https://t.me/' + formattedPhone, '_blank');
    };

    // Открываем чат в whatsapp
    const openWhatsapp = (phone) => {
        // Форматируем номер телефона (убираем все кроме цифр)
        let formattedPhone = phone.replace(/\D/g, '');

        window.open('https://api.whatsapp.com/send/?phone=' + formattedPhone, '_blank');
    };

    return (
        <div className="user__wrapper">
            { children_form.open && <ChildrenForm/> }
            { child_form.open && <ChildForm/> }
            <UserPermissionForm/>
            <ChoiceDebtSubscription/>
            { deposit_list.open && <DepositsList/> }
            { deposit_form.open && <DepositForm/> }
            { change_user_password_form.open && <ChangeUserPasswordForm/> }
            <DebtList/>
            <PaymentForm/>
            <div className="user__box">
                <div className="table__header">
                    <div className="table__caption">Карточка посетителя</div>
                </div>
                <div className="user__main">
                    <div className="user">
                        {
                            currentUser.avatar
                                ?
                                <img
                                    src={ site + currentUser.avatar }
                                    className="user__avatar"
                                    alt={ currentUser.name }
                                    onClick={ () => {
                                        dispatch(watchPhotoAction(currentUser.avatar.replace('_compress_', '_origin_')));
                                    } }
                                />
                                : <div className="user__avatar user__avatar--no-image" />
                        }
                        <div className="user__info">
                            <div
                                className={ `user__name ${ currentUser.sex === 'male' ? 'user__name--male' : currentUser.sex === 'female' ? 'user__name--female' : 'user__name--no-gender' }` }
                            >{ currentUser.name }</div>
                            <div className="user__phone">
                                { currentUser.phone }
                                {
                                    currentUser.phone_approved === 1 &&
                                    <Tippy content={ 'Телефон подтверждён' } >
                                        <div className="user__approved" />
                                    </Tippy>
                                }
                                <div className="user__messenger user__messenger--viber"
                                     onClick={ () => {
                                         openViber(currentUser.phone);
                                     } }
                                />
                                <div className="user__messenger user__messenger--telegram"
                                     onClick={ () => {
                                         openTelegram(currentUser.phone);
                                     } }
                                />
                                <div className="user__messenger user__messenger--whatsapp"
                                     onClick={ () => {
                                         openWhatsapp(currentUser.phone);
                                     } }
                                />
                            </div>
                            {
                                currentUser.email &&
                                <div className="user__email">
                                    { currentUser.email }
                                    {
                                        currentUser.email_approved === 1 &&
                                        <Tippy content={ 'Почта подтверждена' } >
                                            <div className="user__approved" style={{ marginTop: '3px' }} />
                                        </Tippy>
                                    }
                                </div>
                            }
                            {
                                currentUser.additional_id && <div className="user__additional-id">{ currentUser.additional_id }</div>
                            }
                            <div className="user__deposits"
                                onClick={ () => dispatch(getDepositListSagaAction({ user: currentUser.id })) }
                            >{ `Депозит: ${ currentUser.deposits }` }</div>
                            {
                                currentUser.debt_sum !== 0 &&
                                <div className="user__debt-wrapper">
                                    <div className="user__debt-sum"
                                         onClick={ () => {
                                             dispatch(getDebtListThunk({
                                                 u_id: currentUser.id
                                             }));
                                         } }
                                    >{ `Долг: ${ currentUser.debt_sum }` }</div>
                                </div>

                            }
                            {
                                !currentUser.confirm_email &&
                                <div>
                                    <div className="user__confirm-email"
                                         onClick={ () => {
                                             if (window.confirm(`Вы действительно хотите подтвердить адрес электронной почты? \rДелайте это только в случае крайней необходимости. \rНеверно указанная почта не позволит восстановить пароль, в случае необходимости.`)) {
                                                 dispatch(confirmEmailSagaAction({
                                                     user: currentUser.id
                                                 }));
                                             }
                                         } }
                                    >Подтвердить почту</div>
                                </div>
                            }
                            <div className="user__registration">{ `Дата рождения: ${ currentUser.birthday_with_age }` }</div>
                            <div className="user__registration">{ `Дата регистрации: ${ currentUser.date_registration }` }</div>
                            <div className="user__last-visit">{ `Последний визит: ${ currentUser.last_visit }` }</div>
                            {
                                currentUser.sum !== '' && currentUser.subscriptions_count !== '' && currentUser.workouts_count > 0 &&
                                <div className="user__statistic">{ `Сумма: ${ currentUser.sum || 0 }, Абонементов: ${ currentUser.subscriptions_count || 0 }, Тренировок: ${ currentUser.workouts_count || 0 }` }</div>
                            }
                            {
                                currentUser.points
                                    ?
                                    <div className="user__points">{ `Бонусные баллы: ${ currentUser.points }` }</div>
                                    :   false
                            }
                            {
                                currentUser.links.length > 0 &&
                                currentUser.links.map(elem => {
                                    let style = {};

                                    if (elem.ico) {
                                        style = { backgroundImage: `url(${ elem.ico })` };
                                    }

                                    return (
                                        <div key={ elem.link }>
                                            <a href={ elem.link } target="_blank" className="user__link">
                                                <span className="user__link-ico" style={ style }/>
                                                <span className="user__link-name">{ elem.link }</span>
                                            </a>
                                        </div>
                                    );
                                })
                            }
                            {
                                currentUser.note &&
                                <div className="user__note">
                                    <div className="user__note-ico"/>
                                    <div className="user__note-text">{ currentUser.note }</div>
                                </div>
                            }
                        </div>
                        <div className="controls user__controls">
                            <Tippy content={ 'Дети' }>
                                <i className="control control--children" onClick={ () => {
                                    // Запрашиваем права пользователя
                                    dispatch(getChildrenSagaAction({
                                        id: currentUser.id
                                    }));
                                } }/>
                            </Tippy>
                            <Tippy content={ 'Права доступа' }>
                                <i className="control control--permission" onClick={ () => {
                                    // Запрашиваем права пользователя
                                    dispatch(getUserPermissionSagaAction({
                                        id: currentUser.id
                                    }));
                                } }/>
                            </Tippy>
                            <Tippy content={ 'Редактирование данных' }>
                                <i className="control control--edit" onClick={ () => {
                                    dispatch(userFormAction({
                                        open: true,
                                        title: currentUser.name,
                                        id: currentUser.id,
                                        avatar: currentUser.avatar,
                                        name: currentUser.name,
                                        phone: currentUser.phone,
                                        email: currentUser.email,
                                        date_registration: currentUser.date_registration,
                                        sex: currentUser.sex,
                                        note: currentUser.note,
                                        birthday: currentUser.birthday,
                                        additional_id: currentUser.additional_id,
                                        links: currentUser.links
                                    }));
                                } }/>
                            </Tippy>
                            <Tippy content={ 'Смена пароля' }>
                                <i className="control control--change-pass" onClick={ () => {
                                    // Открываем форму смены пароля
                                    dispatch(setChangeUserPasswordFormAction({
                                        ...CHANGE_USER_PASSWORD_FORM_INITIAL,
                                        open: true,
                                        u_id: currentUser.id
                                    }));
                                } }/>
                            </Tippy>
                            <Tippy content={ 'Удаление посетителя' }>
                                <i className="control control--remove" onClick={ () => {
                                    if (window.confirm(`Вы действительно хотите удалить посетителя ${ currentUser.name }?`)) {
                                        dispatch(removeUserSagaAction({
                                            id: currentUser.id
                                        }));
                                    }
                                } }/>
                            </Tippy>
                        </div>
                    </div>
                    <UserWorkoutsCalendar/>
                </div>
            </div>
            {
                currentUser.debt_workouts.length
                ?
                    <div className="user__box">
                        <div className="table__header">
                            <div className="table__caption">Тренировки в долг</div>
                        </div>
                        <div className="table">
                            <div className="table__row table__row--header user__debt">
                                <div className="table__cell table__cell--left">Дата</div>
                                <div className="table__cell">Тип</div>
                                <div className="table__cell">Тренер</div>
                                <div className="table__cell"/>
                            </div>
                            {
                                currentUser.debt_workouts.map(workout => {
                                    return (
                                        <div className="table__row user__debt" key={ workout.id }>
                                            <div className="table__cell table__cell--left">{ workout.date }</div>
                                            <div className="table__cell">{ workout.type }</div>
                                            <div className="table__cell">{ workout.coach }</div>
                                            <div className="table__cell table__cell--hover"
                                                 onClick={ () => {
                                                     dispatch(removeDebtAction({
                                                         open: true,
                                                         workout_id: workout.id
                                                     }));
                                                 } }
                                            >Удалить</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                : false
            }
            {
                currentUser.missed_workouts.length
                    ?
                    <div className="user__box">
                        <div className="table__header">
                            <div className="table__caption">Пропущенные тренировки</div>
                        </div>
                        <div className="table">
                            <div className="table__row table__row--header user__missed-workouts">
                                <div className="table__cell table__cell--left">Дата и время</div>
                                <div className="table__cell">Тренировка</div>
                                <div className="table__cell"/>
                            </div>
                            {
                                currentUser.missed_workouts.map(workout => {
                                    return (
                                        <div className="table__row user__missed-workouts" key={ workout.id }>
                                            <div className="table__cell table__cell--left">{ `${ workout.date } ${ workout.time }` }</div>
                                            <div className="table__cell">{ workout.type }</div>
                                            <div className="table__cell table__cell--hover"
                                                 onClick={ () => {
                                                     if (!window.confirm('Вы действительно хотите удалить пропуск занятия?')) return;

                                                     dispatch(removeMissedWorkoutSagaAction({
                                                         id: workout.id,
                                                         type: 'current_user'
                                                     }));
                                                 } }
                                            >Удалить</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    : false
            }
            {
                current_subscription.current_workouts.length
                ?
                    <CurrentWorkouts/>
                :
                    <div className="user__box">
                        <div className="user__info-filters">
                            <div className="checkbox__wrapper"
                                 onClick={ () => {
                                     setArchive(!archive);
                                     dispatch(getUserInfoSagaAction({ id: currentUser?.id, archive: !archive }));
                                 } }
                            >
                                <div className={ `checkbox ${ archive ? 'checkbox--active' : '' } `}/>
                                <div className="checkbox__caption">Архив абонементов</div>
                            </div>
                        </div>
                        <div className="table__header">
                            <div className="table__caption">Абонементы</div>
                        </div>
                        <div className="button user__add-subscription"
                             onClick={ () => {
                                 dispatch(addSubscriptionFormAction({
                                     ...ADD_SUBSCRIPTION_FORM_INITIAL,
                                     open: true,
                                     user: { id: currentUser.id, name: currentUser.name, sum: currentUser.sum, subscriptions: currentUser.subscriptions_count, deposits: currentUser.deposits },
                                     addition_date: new Date().toLocaleDateString('fr-CA')
                                 }));
                             } }
                        >Добавить абонемент</div>
                        <div className="table user__subscriptions">
                            <div className="table__row table__row--header user__subscription">
                                <div className="table__cell table__cell--left">Тип абонемента</div>
                                <div className="table__cell">Посещения</div>
                                <div className="table__cell">Дата приобритения</div>
                                <div className="table__cell">Дата активации</div>
                                <div className="table__cell">Срок действия</div>
                                <div className="table__cell">Тренер</div>
                                <div className="table__cell">Ограничения</div>
                                <div className="table__cell">Сумма</div>
                                <div className="table__cell">
                                    <div className="user__freeze"/>
                                </div>
                                <div className="table__cell"/>
                                <div className="table__cell"/>
                            </div>
                            {
                                currentUser.subscriptions.map(elem => {
                                    return (
                                        <div key={ elem.id }
                                             className="table__row table__row--hover user__subscription"
                                             style={{ backgroundColor: elem.color }}
                                             onClick={ event => {

                                                 if (!event.target.closest('.context')) {
                                                     dispatch(getWorkoutsFromCertainSubscriptionSagaAction({
                                                         subscription_id: elem.id
                                                     }));
                                                 }
                                             } }
                                        >
                                            <div className="dropdown" style={{ position: 'absolute', width: '150px', right: '28px', marginTop: '21px' }}>
                                                <div className={ `dropdown__items ${ dropdown === 'workout_type' + elem.id ? 'dropdown__items--open' : '' }` }>
                                                    {
                                                        subscription_types.map(el => {
                                                            return (
                                                                <div className="dropdown__item"
                                                                     key={ el.id }
                                                                     onClick={ event => {
                                                                         event.preventDefault();
                                                                         event.stopPropagation();

                                                                         dispatch(addRecordThunk({
                                                                             subscription_id: elem.id,
                                                                             date: 'today',
                                                                             workout_type: el.id
                                                                         }));

                                                                         dispatch(dropdownAction(null));
                                                                     } }
                                                                >{ el.name }</div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            <ContextMenu data={{
                                                open: elem.id === context,
                                                style: { right: 28 },
                                                menu: data?.activation_date !== '' && data?.expire_date ? menu : menuNotActivation
                                            }}/>
                                            {
                                                elem.family || elem.note
                                                    ?
                                                    <Tippy content={ `${ elem.family ? 'Семейный абонемент \n' : '' } ${ elem.note }` }>
                                                        <div className="subscription__info"/>
                                                    </Tippy>
                                                    : false
                                            }
                                            <div className="table__cell table__cell--left">
                                                {
                                                    elem.freezed === 1
                                                        ? <Tippy content={ elem.freezed_dates }>
                                                            <div className="subscription__freezed"/>
                                                        </Tippy>
                                                        : false }
                                                { elem.type?.name }
                                                {
                                                    elem.establishment &&
                                                    <div className="subscription__address">{ elem.establishment }</div>
                                                }
                                            </div>
                                            <div className="table__cell">{ `${ elem.workouts_done } / ${ elem.times }` }</div>
                                            <div className="table__cell">{ elem.buy_date }</div>
                                            <div className={ `table__cell ${ elem.activation_date === '' ? 'table__cell--inactive' : '' }` }>{
                                                elem.activation_date ? new Date(elem.activation_date).toLocaleDateString('ru-Ru') : 'Не активирован'
                                            }</div>
                                            <div className="table__cell">{ elem.expire_date ? new Date(elem.expire_date).toLocaleDateString('ru-Ru') : '' }</div>
                                            <div className="table__cell">{ elem.coach.name }</div>
                                            <div className="table__cell">{ elem.time_constraint?.name }</div>
                                            <div className="table__cell">{ elem.cost }</div>
                                            <div className="table__cell">
                                                {
                                                    elem.freeze_logs
                                                    ?
                                                        <Tippy content={ elem.freeze_logs }>
                                                            <div>{ `${ elem.freeze_times }/${ elem.freeze_days }` }</div>
                                                        </Tippy>
                                                    :
                                                        `${ elem.freeze_times }/${ elem.freeze_days }`
                                                }
                                            </div>
                                            <div className="table__cell">
                                                <div className="user__record">
                                                    <div className="user__record-now"
                                                         onClick={ event => {
                                                             event.preventDefault();
                                                             event.stopPropagation();
                                                             dispatch(addRecordThunk({
                                                                 subscription_id: elem.id,
                                                                 date: 'today'
                                                             }));
                                                         } }
                                                    >Списать</div>
                                                    <div className="user__record-type"
                                                         onClick={ event => {
                                                             event.preventDefault();
                                                             event.stopPropagation();
                                                             dispatch(dropdownAction('workout_type' + elem.id));
                                                         } }
                                                    />
                                                </div>
                                            </div>
                                            <i className="menu__button" onClick={ event => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                dispatch(contextAction(elem.id));
                                            } }/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
            }
        </div>
    );
};

export default CurrentUser;